function initVintagesCarousel(){
    "use strict";


	$('.vintages--content .vintages-carousel').on('init', function(event, slick){

		 if($('.vintages-carousel-control .slick-prev').length>0){
	    	$('.vintages-carousel-control .slick-prev').append('<span id="prev_year" class="visible-xs"></span>');
	    }
	 	
	  	if($('.vintages-carousel-control .slick-next').length>0){
	 		$('.vintages-carousel-control .slick-next').append('<span id="next_year" class="visible-xs"></span>');
	 	}

		var currentIndex = $('.vintages--content .vintages-carousel .slick-active').data('slick-index');
		var total_slides = $('.vintages--content .vintages-carousel .vintages-item').length;

		var prev_index='', next_index='';


		$('.vintages--content .vintages-carousel .vintages-item').each(function() {
		   
		    if ( $(this).data('slick-index') === currentIndex+1  &&  currentIndex !== total_slides-1 ) {
		      	next_index = $(this).data('year');
		      	$('#next_year').html(next_index);
		    } else{

		    	if(currentIndex=== total_slides-1){
		    		next_index =  $('.vintages--content .vintages-carousel .vintages-item:first-of-type').data('year');
		    		console.log(next_index);
		    	 	$('#next_year').html(next_index);
		    	}
		    	
		    }

		    if(currentIndex==0){
			   prev_index = $('.vintages--content .vintages-carousel .vintages-item:last').data('year');
			   $('#prev_year').html(prev_index);
			}else{
				  if ( $(this).data('slick-index') === currentIndex-1 ) {
				  		 prev_index = $(this).data('year');
				  		 $('#prev_year').html(prev_index);
				  }
			}
		 });		
	});

	

    $('.vintages--content .vintages-carousel').slick({
		dots: false,
		arrows: true,
		nav: false,
		infinite: true,
		speed: 300, 
		slidesToShow: 1,
		slidesToScroll: 1,
		fade: true,
  		cssEase: 'linear',
		prevArrow: PREV_ARROW,
		nextArrow: NEXT_ARROW,
		appendArrows:'.vintages-carousel-control',		
		adaptiveHeight: true
	});

 	

	$('.vintages--content .vintages-carousel').on('afterChange', function(event, slick, currentSlide){
 		var currentIndex = $('.vintages--content .vintages-carousel .slick-active').data('slick-index');
		var total_slides = $('.vintages--content .vintages-carousel .vintages-item').length;
		
		var prev_index='', next_index='';

		$('.vintages--content .vintages-carousel .vintages-item').each(function() {
		    if ( $(this).data('slick-index') === currentIndex+1 &&  currentIndex!==total_slides-1 ) {
		      	next_index = $(this).data('year');
		      	 $('#next_year').html(next_index);
		    } else{
		    	
		    	if(currentIndex=== total_slides-1){
		    		next_index =  $('.vintages--content .vintages-carousel .vintages-item:first-of-type').data('year');
		    	 	$('#next_year').html(next_index);
		    	}
		    }

		    if(currentIndex==0){
			   prev_index = $('.vintages--content .vintages-carousel .vintages-item:last').data('year');
			   $('#prev_year').html(prev_index);
			}else{
				  if ( $(this).data('slick-index') === currentIndex-1 ) {
				  		 prev_index = $(this).data('year');
				  		 $('#prev_year').html(prev_index);
				  }
			}


		 });

		$('.carousel-trigger').each(function() {
			
			

			if ( $(this).data('index') === currentIndex ) {
				$('.carousel-trigger').removeClass('active');
				$(this).addClass('active');
			}

		 });

	});





	$('.carousel-trigger').on('click', function(e){
        var slideIndex = $(this).data('index');
		$('.vintages-carousel').slick('slickGoTo', slideIndex, false);
		e.preventDefault();
	});
}

function initFeaturedCarousel(){
    "use strict";

    $('#featured-carousel').slick({
		dots: false,
		arrows: true,
		nav: false,
		infinite: true,
		speed: 300,
		slidesToShow: 2,
		slidesToScroll: 1,
		prevArrow: PREV_ARROW,
		nextArrow: NEXT_ARROW,
		appendArrows:'.wines-navigation',
		responsive: [
		    {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,					
				}
		    },
    	]
		
	});



}






